(function () {

  function getAddressObject(address_components) {
        var ShouldBeComponent = {
            home: ["street_number"],
            postal_code: ["postal_code"],
            street: ["street_address", "route"],
            region: [
              "administrative_area_level_1",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "administrative_area_level_4",
              "administrative_area_level_5"
            ],
            city: [
              "locality",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "sublocality_level_3",
              "sublocality_level_4"
            ],
            county: [
              "administrative_area_level_2",
            ],
            country: [
            "country"
            ]
          };

          var address = {
            home: "",
            postal_code: "",
            street: "",
            region: "",
            city: "",
            country: ""
          };
          address_components.forEach(component => {
            for (var shouldBe in ShouldBeComponent) {
              if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                if (shouldBe === "country") {
                    address[shouldBe] = component.long_name;
                 // address[shouldBe] = component.short_name + "-" +component.long_name;
                } else {
                  address[shouldBe] = component.long_name;
                }
              }
            }
          });
          return address;
       // }
  }

    const fillBusinessForm = (places) => {
        let placesinfo = JSON.parse(places);
        var addressResult = getAddressObject(placesinfo?.address_components);
        $("#company").val(placesinfo?.name);
        $("#phone").val(placesinfo?.formatted_phone_number);
        $("#address").val(addressResult?.home + " " + addressResult?.street);
        $("#state").val(addressResult?.region);
        $("#city").val(addressResult?.city);
        $("#country").val(addressResult?.country);
        $("#zip_code").val(addressResult?.postal_code);
        $("#county").val(addressResult?.county);
        $("#latitude").val(placesinfo?.geometry?.location?.lat);
        $("#longitude").val(placesinfo?.geometry?.location?.lng);


        // var resultObject = search("street_number", placesinfo?.address_components);

        $("#url").val(placesinfo?.website);

     // var locatorSection = document.getElementById("locator-input-section")
    }
    if($("#google_search_string").length > 0 ){
        var input = document.getElementById("google_search_string");
        var autocomplete = new google.maps.places.Autocomplete(input);

        $("#smart_google_search_btn").click(function(){
            let valid = false;
             if (!$('#google_search_string').val()) {
                if ($("#google_search_string").parent().next(".validation").length == 0) // only add if not added
                {
                    $("#google_search_string").parent().after("<div class='validation' style='color:red;margin-bottom: 20px;'>Please enter business, address, phone</div>");

                }
            } else {
                $("#google_search_string").parent().next(".validation").remove(); // remove it
                 valid = true;

            }

            if(valid == true){
                
                var place = null;

                place = autocomplete.getPlace();
                let placeId = place?.place_id;
                if (typeof placeId !== 'undefined'){
                    $('.no-result').addClass('d-none');
                    $("#cover-spin").show();
                    $("#place_id").val(placeId);
                    $.ajax({
                        type: "post",
                        url: baseUrl +"/business-data-api",
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        data: {"place_id":placeId},
                        success: function (data) {
                            let apiUid = data?.tasks[0]?.id;
                            if(apiUid !=""){
                                 $("#hndtask_id").val(apiUid);
                                 $("#smart_business_manual_form").removeClass('opacity-0');
                                 $("#display_heading_div").show();
                                 $("#display_button_div").show();
                                 $("#display_iagree_div").show();
                                 $("#smart_google_result").val(JSON.stringify(place));
                                 $("#googleSmartPlaceResult").html(data);
                                 fillBusinessForm(JSON.stringify(place));
                            }
                            else{
                                $("#smart_business_manual_form").removeClass('opacity-0');
                                $("#display_heading_div").show();
                                $("#display_button_div").show();
                                $("#display_iagree_div").show();
                            }

                        },
                        error: function(error){
                        },
                        complete:function(data){
                            $("#cover-spin").hide();
                        }
                    });
                }
                else{
                    $('#businessName').html($('#google_search_string').val());
                    $('.no-result').removeClass('d-none');
                    $("#smart_business_manual_form").removeClass('opacity-0');
                    $("#display_heading_div").show();
                    $("#display_button_div").show();
                    $("#display_iagree_div").show();
                   // alert("here2");
                }
                


            }
            showIntroStage2();


        });
    }

    $("#post-ideas").submit(function(e) {
         e.preventDefault();
        var spinner = $('#cover-spin');
        let term = $("#search-keyword-ideas").val();
        if(term == ""){

            alert("please enter term");
            $("#search-keyword-ideas").focus();
            return false;
        }
        spinner.show();
        $.ajax({
                url: '/keyword-tool/'+term,
                type: 'GET',
                dataType: 'json', // added data type
                success: function(res) {
                     let tableContent = '';
                    if(res.status_code == '20000'){
                        if(res?.tasks[0]?.result){
                            tableContent = `<table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Keyword</th>
                                                        <th>Competition</th>
                                                        <th>Search volume</th>
                                                    </tr>
                                                </thead>
                                            `;
                            results = res?.tasks[0]?.result;
                            let tbodyContent = '';
                            results.forEach((e) => {
                                tbodyContent +=   `<tr><td> ${e.keyword} </td><td> ${e.competition} </td><td> ${e.search_volume} </td></tr>`
                            });

                            if(tbodyContent !=''){
                                tableContent += tbodyContent + `</table>`;
                                $("#display-result-ideas").html(tableContent);

                            }
                        }
                    }
                    spinner.hide();
                },
                // success: function( data, textStatus, jQxhr ){
                //     $('#response pre').html( data );
                // },
                error: function( jqXhr, textStatus, errorThrown ){
                },
                done: function(resp){
                    spinner.hide();
                }
            });
    });


    $("#copy-point-tool").submit(function(e) {
        e.preventDefault();
       var spinner = $('#cover-spin');
       let term = $("#search-term").val();
       if(term == ""){

           alert("please enter term");
           $("#search-keyword-ideas").focus();
           return false;
       }
       spinner.show();
       $.ajax({
               url: '/copy-point-tool/'+term,
               type: 'GET',
               dataType: 'json', // added data type
               success: function(res) {
                    let tableContent = '';
                   if(res !=''){
                    $("#display-result-copypoint").html("<pre>"+res+"</pre>");
                    $("#display-result-copypoint").show();

                    //    if(res?.tasks[0]?.result){
                    //        tableContent = `<table class="table table-bordered">
                    //                            <thead>
                    //                                <tr>
                    //                                    <th>Keyword</th>
                    //                                    <th>Competition</th>
                    //                                    <th>Search volume</th>
                    //                                </tr>
                    //                            </thead>
                    //                        `;
                    //        results = res?.tasks[0]?.result;
                    //        let tbodyContent = '';
                    //        results.forEach((e) => {
                    //            tbodyContent +=   `<tr><td> ${e.keyword} </td><td> ${e.competition} </td><td> ${e.search_volume} </td></tr>`
                    //        });

                    //        if(tbodyContent !=''){
                    //            tableContent += tbodyContent + `</table>`;
                    //            $("#display-result-copypoint").html(tableContent);

                    //        }
                    //    }
                   }
                   spinner.hide();
               },
               // success: function( data, textStatus, jQxhr ){
               //     $('#response pre').html( data );
               // },
               error: function( jqXhr, textStatus, errorThrown ){
               },
               done: function(resp){
                   spinner.hide();
               }
           });
   });



    $('#heading_lookup').select2({
        placeholder: "Select Primary Category",
        allowClear: true,
        multiple: false,
    });

    $("#post-heading-lookup").submit(function(e) {
        e.preventDefault();
        let selected_heading = $('#heading_lookup option:selected').val();
        var spinner = $('#cover-spin');
         if(selected_heading == ""){
            alert("please select heading");
            return false;
        }

        if(selected_heading != ""){
            spinner.show();
            $.ajax({
                    url: '/keyword-tool/'+selected_heading,
                    type: 'GET',
                    dataType: 'json', // added data type
                    success: function(res) {
                         let tableContent = '';
                        if(res.status_code == '20000'){
                            if(res?.tasks[0]?.result){
                                tableContent = `<table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Keyword</th>
                                                            <th>Competition</th>
                                                            <th>Search volume</th>
                                                        </tr>
                                                    </thead>
                                                `;
                                results = res?.tasks[0]?.result;
                                let tbodyContent = '';
                                results.forEach((e) => {
                                    tbodyContent +=   `<tr><td> ${e.keyword} </td><td> ${e.competition} </td><td> ${e.search_volume} </td></tr>`
                                });

                                if(tbodyContent !=''){
                                    tableContent += tbodyContent + `</table>`;
                                    $("#display-lookup-ideas").html(tableContent);

                                }
                            }
                        }
                        spinner.hide();
                    },
                    // success: function( data, textStatus, jQxhr ){
                    //     $('#response pre').html( data );
                    // },
                    error: function( jqXhr, textStatus, errorThrown ){
                    },
                    done: function(resp){
                        spinner.hide();
                    }
            });
        }
    });


    $('#smart_heading_selected').select2({
        placeholder: "Select Primary Category",
        allowClear: true,
        multiple: false,
        ajax: {
            url: baseUrl + "/business/heading",
            dataType: 'json',
            type: "GET",
            quietMillis: 50,
            data: function (params) {
                return {
                    term: params.term,
                    page: params.current_page
                };
            },
            processResults: function (data,params) {
                params.current_page = data.current_page + 1;
                return {
                    results: $.map(data.data, function (item) {
                        let textValue = (item.sub_headings_count > 0) ? item.heading_name + "("+item.sub_headings_count+")": item.heading_name;
                        return {
                            text: textValue,
                            id: item.id,
                            gcid_name:item.gcid_name,
                        }
                    }),
                    pagination: {
                        more: data.last_page > data.current_page
                    }
                };
            },
        }
   });
    // $("#smart_heading_selected").select2().change(function() {
    //     $(this).valid();
    //   });

    if($('#smart_heading_selected').length > 0){
        $('#smart_heading_selected').on('change', function() {
            let gcid_name = $('#smart_gcid_selected').find(":selected").text();
            if(gcid_name){
                $('#gcidName').html("<b>GCID:</b> "+ gcid_name);
                $('#hdn_gcid_name').val(gcid_name);
            }else if($(this).select2('data')[0]){
                gcid_name=$(this).select2('data')[0].gcid_name || '';
                $('#gcidName').html("<b>GCID:</b> "+ gcid_name);
                $('#hdn_gcid_name').val(gcid_name);
            }else{
                $('#gcidName').html("<b>GCID:</b> ");
                $('#hdn_gcid_name').val('');
            }
        });

        $('#smart_gcid_selected').on('change', function() {
            let gcid_name = $('#smart_gcid_selected').find(":selected").text();
            if(gcid_name){
                $('#gcidName').html("<b>GCID:</b> "+ gcid_name);
                $('#hdn_gcid_name').val(gcid_name);
            }else if($('#smart_heading_selected').select2('data')[0]){
                gcid_name=$('#smart_heading_selected').select2('data')[0].gcid_name || '';
                $('#gcidName').html("<b>GCID:</b> "+ gcid_name);
                $('#hdn_gcid_name').val(gcid_name);
            }else{
                $('#gcidName').html("<b>GCID:</b> ");
                $('#hdn_gcid_name').val('');
            }
        });
    }

    if( $('#browserTimeZone').length > 0 && $('#browserTimeZone').val() == ''){
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        $('#browserTimeZone').val(tz);
    }
    
    $("#smart_gcid_selected").select2({
        //minimumInputLength: 2,
        //tags: [],
        allowClear: true,
        placeholder: "Select a GCID",
        ajax: {
            url: baseUrl + "/business/gcid",
            dataType: 'json',
            type: "GET",
            quietMillis: 50,
            data: function (params) {
                return {
                    term: params.term,
                    page: params.current_page
                };
            },
            processResults: function (data,params) {
                params.current_page = data.current_page + 1;
                return {
                    results: $.map(data.data, function (item) {
                        return {
                            text: item.gcid_name,
                            id: item.gcid_name
                        }
                    }),
                    pagination: {
                        more: data.last_page > data.current_page
                    }
                };
            },
        }
    })
    // var maxLength = 250;
    // $('#smart_sheet_form textarea').keyup(function() {
    //   var textlen = maxLength - $(this).val().length;
    //   $('#rchars').text(textlen);
    // });

    var maxLength = 250;
    $('#advice_local_form textarea').keyup(function() {
      var textlen = maxLength - $(this).val().length;
      $('#rchars').text(textlen);
    });

    $("#advice_local_process_btn").click(function(e){
        e.preventDefault();
        $("#cover-spin").show();
         let valid = false;
         if (!$('#company').val()) {
           $(".company-error").show();
           return false;
        }
        else{
            $(".company-error").hide();
        }
        if (!$('#phone').val()) {
           $(".phone-error").show();
         //  $("#cover-spin").hide();
           return false;
        }
        else{
            $(".phone-error").hide();
        }


        if ($('#description').val() == "") {
           $(".description-error").show();
            return false;
        }
        else{
            $(".description-error").hide();
        }

        let currentLen = $('#description').val().length;
        var textlen = 250 - currentLen;
        if (textlen > 0) {
           $(".description-error").text("250 characeters are mandatory to submit listing to Listings Engine.");
           $(".description-error").show();
           return false;
        }
        else{
            $(".description-error").hide();
        }
        $("#cover-spin").hide();
        // $("#start_newsheet").show();
        $("#advice_local_form").submit();

    });

    $("#generate_sheet_btn").click(function(e){
        e.preventDefault();
        

        let selected_heading = $('#smart_heading_selected option:selected').val();
        //  var data = $(".select2 option:selected").text();
        // $("#test").val(data);

         // $("#cover-spin").show();
         let valid = false;
         if (!$('#company').val()) {
           $(".company-error").show();
         //  $("#cover-spin").hide();
           return false;
        }
        else{
            $(".company-error").hide();
        }
        if (!$('#phone').val()) {
           $(".phone-error").show();
         //  $("#cover-spin").hide();
           return false;
        }
        else{
            $(".phone-error").hide();
        }
        if (selected_heading =="") {
           $(".heading-error").show();
        //   $("#cover-spin").hide();
           return false;
        }
        else{
            $(".heading-error").hide();
        }

        // if ($('#description').val() == "") {
        //    $(".description-error").show();
        // //   $("#cover-spin").hide();
        //    return false;
        // }
        // else{
        //     $(".description-error").hide();
        // }

        // let currentLen = $('#description').val().length;
        // var textlen = 250 - currentLen;
        // if (textlen > 0) {
        //    $(".description-error").show();
        //    return false;
        // }
        // else{
        //     $(".description-error").hide();
        // }
        $(".spinner-border").show();
        $("#overlay").show();
        // $("#start_newsheet").show();
        $("#smart_sheet_form").submit();
        if($('#smart_sheet_form').valid()){
            $("#generate_sheet_btn").hide();
        }
        $(".spinner-border").hide();
        $("#overlay").hide();
        // $(".spinner-border").hide();
        // $("#overlay").hide();
        // $("#start_newsheet").show();
    });
    if($("#smartAutocomplete").length > 0 ){
        // var locatorSection = document.getElementById("locator-input-section")
        var input = document.getElementById("smartAutocomplete");
        var smartAutocomplete = new google.maps.places.Autocomplete(input);
        $("#search_btn").click(function(){
            var place = smartAutocomplete.getPlace();

            $.ajax({
                type: "post",
                url: baseUrl +"/display-smart-search-info",
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {"search_result":JSON.stringify(place)},
                success: function (data) {
                    if(data){
                        $("#smart_show_div").show();
                        $("#smart_google_result").val(JSON.stringify(place));
                        $("#googleSmartPlaceResult").html(data);
                    }

                },
            });

        });
    }

    function showIntro() {
        var intro = localStorage.getItem("intro");
        if(!intro){
            introJs('#google_search_box').start();
            localStorage.setItem("intro",1);
        }
    }

    

    function showIntroStage2() {
        var introStage2 = localStorage.getItem("introStage2");
        if(!introStage2){
            introJs('#smart_business_manual_form').onexit(function() {
                introJs('#display_heading_div').start();
            }).start();

            localStorage.setItem("introStage2",1);
        }
    }
    
    $(window).on("load", function(){
        if($('#google_search_string').length > 0){
            showIntro();
        }

        $('#google_search_string').on('keyup',function(){
            $('.no-result').addClass('d-none');
        })
    });
    $('#smart_sheet_form').validate({
        errorPlacement: function (error, element) {
            if(element.hasClass('select2') && element.next('.select2-container').length) {
                error.insertAfter(element.next('.select2-container'));
                
            }
        },
        rules:{
            phone:'required',
            'smart_heading_selected[]':'required'
        }
    });
})();
